import React from 'react';
import { withWrapper } from '@shared/react';
import {
    ClientDetailsTableProvider,
    useClientDetailsTable,
    getTransactionsTableColumns,
    UserManagement_TABLE_TITLE,
    UserManagement_TABLE_INFO_URL,
} from './lib';
import { Table } from '@features/Table';
import './ClientDetailsTable.scss';

const ClientDetailsTableContent: React.FC<{ userId: number; fromRIA: boolean }> = ({ userId, fromRIA }) => {
    const { ClientDetailsBody, paginationOptions, clientLoading } = useClientDetailsTable();

    const userStorage = localStorage.getItem('User');
    let userObject = JSON.parse(userStorage ? userStorage : '');
    if (ClientDetailsBody.length > 0) {
        return (
            <Table
                columns={getTransactionsTableColumns(fromRIA)}
                data={ClientDetailsBody}
                dataLoading={clientLoading}
                tableTitle={userObject ? null : UserManagement_TABLE_TITLE}
                infoLink={UserManagement_TABLE_INFO_URL}
                paginationOptions={paginationOptions}
                row={undefined}
                tableToShow='showTable'
                noScroll={true}
            />
        );
    } else {
        return null;
    }
};

export const UnassignClientDetailsTable = withWrapper(ClientDetailsTableProvider)(ClientDetailsTableContent);
